import React from 'react';
// import { signUpContext } from '../../../pages/signup';
import { Link } from 'react-router-dom';
import BlueButton from '../ui/BlueButton';
import { Formik, Form, ErrorMessage, Field } from "formik";
import * as Yup from "yup";
import styles from './SignIn.module.css';
import axios from 'axios';
import useAuth from '../../hooks/useAuth';
import { useLocation, useNavigate } from 'react-router-dom'; 



const SignIn = () => {
    
    const location = useLocation();
    const navigate = useNavigate();
    const from = location.state?.from?.pathname || "/";

    const { auth, setAuth } = useAuth();

    const initialValues = {
      email: "",
      password: "",
    };
    const onSubmit = (values) => {
      console.log("onSubmit", values);
      login(values);
    };
    const login = (values) => {
        console.log(values.email);
        const data1 = { email: values.email, password: values.password };
        // console.log(data);
        axios({
          method: 'post', //you can set what request you want to be
          url: `${process.env.REACT_APP_HOST1}/auth/login`,
          data: data1,
          headers: {
            "Content-Type": "application/json"
          }
        }).then(async (response) => {
          if (response.data.error) {
            alert(response.data.error);
            // console.log(response.data);
            // setWrongAttempts(1);
          } else {
            localStorage.setItem("accessToken", response.data.token);
            setAuth({
              name: response.data.name,
              id: response.data.id,
              status: true,
            });
            console.log(await auth,' <- auth');
            navigate(from, { replace: true });//modify for null
          }
        });
      };
  
    const validationSchema = Yup.object({
      email: Yup.string(),
      password: Yup.string()
        .min(8, 'Password must be at least 8 characters')
        .matches(/[A-Z]/, 'Password must contain at least one uppercase letter')
        .matches(/[a-z]/, 'Password must contain at least one lowercase letter')
        .matches(/[0-9]/, 'Password must contain at least one digit')
        .matches(/[@$!%*?&]/, 'Password must contain at least one special character')
        .required('Password is required'),
    });
    
    return (<> 
        <h1 className='text-4xl'>Sign In</h1>
        <div className={styles.container}>

            <Formik
                initialValues={initialValues}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
            >
                {() => (
                    <Form>
                        <div className={styles.inputContainer}>
                            <Field className={styles.input} name="email" placeholder="Email Id" />
                            <div className="error">
                                <ErrorMessage name="email" component="span" />
                            </div>
                            <Field className={styles.input} name="password" placeholder="Password" type="password" />
                            <div className={styles.error}>
                                <ErrorMessage name="password" component="span" />
                            </div>
                        </div>
                        <BlueButton extraStyle={{ width: '100%' }} type={'submit'}><p>SignIn</p></BlueButton>
                    </Form>
                )}
            </Formik>
            <div className={styles.container2}>
                <p className=''>Dont have an account?</p>
                <Link className='' to='/signup' state={{ from: location }} replace>SignUp</Link></div>
            <div >
                <BlueButton extraStyle={{ width: '100%', display: 'flex', alignItems: 'center' }} type={'submit'} onClick={onSubmit}><img className={styles.googleSvg} src="GoogleLogo.svg" alt="Google logo" />Login with Google</BlueButton>
            </div>
        </div>
        </>
        )
  }

export default SignIn;
